import { PropsWithChildren } from "react";
import Sheet from "react-modal-sheet";
import { SheetDetent } from "react-modal-sheet/dist/types";

import { useDetectKeyboardOpen } from "@/hooks/useDetectKeyboardOpen";

import { StyledSheet } from "./styles";

interface ISheetModal extends PropsWithChildren {
  isOpen: boolean;
  closeModal: () => void;
  snapPoints?: number[];
  detent?: SheetDetent;
}

export const SheetModal = ({ isOpen, closeModal, children, detent, snapPoints = [-50, 100, 0] }: ISheetModal) => {
  const { visualViewportHeight, isKeyboardOpen } = useDetectKeyboardOpen();
  return (
    <StyledSheet
      isOpen={isOpen}
      onClose={closeModal}
      initialSnap={0}
      snapPoints={snapPoints}
      detent={detent}
      $height={isKeyboardOpen ? visualViewportHeight : undefined}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>{children}</Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={closeModal} />
    </StyledSheet>
  );
};
